import { getClassTitle } from '../DataAndAPIs/ClassSections'
import { videoLink } from '../Activities/Activity'
import { internalLink, externalLink } from '../DataAndAPIs/Links'

// Example Architecture video link: https://coursevideos.blob.core.windows.net/bass/Chapter-00-lecture.mp4

export const prefaceLecture = () => { return internalLink('lecture', '/activity-architecture/Chapter-00-lecture') }
export const chapter01Lecture = () => { return internalLink('lecture', '/activity-architecture/Chapter-01-lecture') }
export const chapter02Lecture = () => { return internalLink('lecture', '/activity-architecture/Chapter-02-lecture') }
export const chapter03Lecture = () => { return internalLink('lecture', '/activity-architecture/Chapter-03-lecture') }
export const chapter04Lecture = () => { return internalLink('lecture', '/activity-architecture/Chapter-04-lecture') }
export const chapters05To12Lecture = () => { return internalLink('lecture', '/activity-architecture/Chapter-05-to-12-Overview') }
export const chapter13Lecture = () => { return internalLink('lecture', '/activity-architecture/Chapter-13-lecture') }

export const chapter15Lecture = () => { return internalLink('lecture', '/activity-architecture/chapter-15-lecture') }
export const chapter16Lecture = () => { return internalLink('lecture', '/activity-architecture/chapter-16-lecture') }
export const chapter17Lecture = () => { return internalLink('lecture', '/activity-architecture/chapter-17-lecture') }
export const chapter18Lecture = () => { return internalLink('lecture', '/activity-architecture/chapter-18-lecture') }
export const chapter20Lecture = () => { return internalLink('lecture', '/activity-architecture/chapter-20-lecture') }
export const chapter22Lecture = () => { return internalLink('lecture', '/activity-architecture/chapter-22-lecture') }
export const chapter26Lecture = () => { return internalLink('lecture', '/activity-architecture/chapter-26-lecture') }

export const ActivityArchitectureVideo = (topic) => {
	const link = 'https://coursevideos.blob.core.windows.net/bass/'+topic+'.mp4'
	const topicSlides = topic.replace(/-lecture/g, '-slides')
	const slidesDownloadLink = 'https://coursevideos.blob.core.windows.net/bass/'+topicSlides+'.pptx'
	console.log('Video link: ', link)
	return ( <div>
		<h4>{getClassTitle()}</h4>
		{videoLink('', link)}

		<br />
		<p>Download Slides: {externalLink('[download]', slidesDownloadLink)}</p>
	</div> )
}